import { Link } from '@tkww/orion-web-ds-action';
import { Icon } from '@tkww/orion-web-ds-graphic';
import { compose } from '@xo-union/react-css-modules';
import React from 'react';
import SectionHeader from '../../../../components/shared/SectionHeader';
import Styles from './styles.scss';

type HeaderProps = {
	city: string;
	name: string;
	stateCode: string;
	onLocationPress: () => void;
};

const Header = ({ name, city, stateCode, onLocationPress }: HeaderProps) => (
	<SectionHeader>
		{`Top ${name} near `}
		<Link
			as="button"
			type="button"
			tabIndex={0}
			classes={compose({ link: Styles.link })}
			onClick={onLocationPress}
			id="location-modal-launcher"
			styleType="primary"
		>
			{`${city}, ${stateCode}`}
			<Icon
				// @ts-expect-error: name prop is not defined for Icon
				name="pencil"
				size="md"
				className={Styles.edit}
			/>
		</Link>
	</SectionHeader>
);

export default Header;
